
const initState = [];

const PacketDDReducer = (state = initState, action) => {
    switch(action.type) {
        case  'PacketDD' : return  action.payload;
        default: return state;
    }
}
export default PacketDDReducer;